ixModuleRouting("impactx.communicationconfig", {
    "/communicationconfiglist": {
        template: "<ixa-communicationconfig-list></ixa-communicationconfig-list>",
        process: "CommunicationConfig",
        workspace: "admin"
    },
    "/communicationconfiguration/:id": {
        template: "<ixa-communicationconfig-dialog></ixa-communicationconfig-dialog>",
        process: "CommunicationConfig",
        workspace: "admin"
    }
});